module.exports = __webpack_public_path__ + "img/san_pham_nn.8c680a9b.jpg";